<template>
  <div class="tabBar_box">
    <NuxtLink  v-for="(item) in TAB_BAR_LIST" :key="item.name" :to="item.path">
      <div class="tabBar_item">
        <NuxtImg :src="$route.path === item.path ? item.activeIcon : item.icon" alt="home"></NuxtImg>
        <span :class="{active: $route.path === item.path}">{{ $t(item.name) }}</span>
      </div>
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
import {TAB_BAR_LIST} from "../constant";
</script>

<style scoped lang="scss">
.tabBar_box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 9px 52px;
  border-top: 1px solid #F4F4F4;

  .tabBar_item {
    display: flex;
    flex-direction: column;
    color: #32343A;
    font-weight: 500;
    align-items: center;

    img {
      width: 25px;
      height: 25px;
    }

    span {
      font-size: 11px;

    }
   .active {
      color: #FF1979;
    }
  }
}

</style>
